import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, space } = theme

export const Wrapper = styled.footer`
  width: 100%;
  background-color: ${colors['neutral-background-contrast-medium']};
  padding-top: ${space['spacing-xl']};
  padding-bottom: ${space['spacing-xl']};
`
